<template>
<div class="content-i">

    <div class="content-box">
        <div class="element-wrapper">
            <div class="element-actions d-none d-sm-block">
                <a class="btn btn-primary btn-sm">
                    <i class="os-icon os-icon-ui-22"></i>
                    <router-link tag="span" :to="`/projectdesk/project/add`">
                        Add Project
                    </router-link>
                </a>
            </div>
            <h6 class="element-header">
                Projects
            </h6>
            <Loader v-if="isLoading" />
                <EmptyState v-else-if="projects.length == 0" >
                    <div slot="empty_state_text">
                        No Projects
                    </div>
                </EmptyState>
            <div class="element-box" v-else>
                <div class="table-responsive">
                    <table class="table table-striped table-lightborder">
                        <thead>
                            <tr>
                                <th>Project ID</th>
                                <th>Name</th>
                                <th>Priority</th>
                                <th>Status</th>
                                <th>Contributors</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Last Updated</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody >

                            <tr v-for="project in projects" :key="project.id_projectdesk_project">
                                <td class="nowrap">
                                    {{project.code}}
                                </td>
                                <td class="nowrap">
                                    {{project.name}}
                                </td>
                                <td class="nowrap">
                                    <strong class="badge badge-danger" v-if="project.priority == 1">High</strong>
                                    <strong class="badge badge-primary" v-if="project.priority == 2">Normal</strong>
                                    <strong class="badge badge-warning" v-if="project.priority == 3">Low</strong>
                                </td>
                                <td class="nowrap capitalize" :class="formatStatus(project.status)">
                                    {{formatStatus(project.status)}}
                                </td>
                                <td>
                                    <div class="cell-image-list">
                                        <div v-for="contributor in formatContributors(project)" class="cell-img" :style="'background-image: url('+contributor.avatar+')'"></div>
                                    </div>
                                </td>
                                <td>
                                    {{project.start_date}}
                                </td>
                                <td>
                                    {{project.end_date}}
                                </td>
                                <td>
                                    {{project.updated_at}}
                                </td>
                                <td>
                                    <router-link tag="a" :to="`/projectdesk/projects/${project.id_projectdesk_project}`">
                                        View
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
            <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getProjects()" :offset="5" ></Pagination>
        </div>

    </div>
</div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import CommonFunctions from '@/mixins/common-functions.js'
import TableLoader from '@/components/common/TableLoader'
import Loader from '@/components/common/Loader'

export default {
  name: 'session-list',
  mixins: [CommonFunctions],
  components: { TableLoader, Loader, Pagination },
  data () {
    return {
      isLoading: true,
      projects: [],
      pagination: {
        'current_page': 1
      },
      statusFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Pending Import', 'key': '0' },
        { 'name': 'In Progress', 'key': '1' },
        { 'name': 'Complete', 'key': '2' },
        { 'name': 'Cancelled', 'key': '3' }
      ]
    }
  },
  mounted: function () {
    this.getProjects()
  },
  methods: {
    getProjects: function () {
      var self = this
      const url = '/projectdesk/projects?page=' + this.pagination.current_page
      self.isLoading = true
      this.$http.get(url, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.projects = response.data.projects.data
          self.pagination = response.data.projects
          self.isLoading = false
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('showToastAPIError')
        })
    },
    addSession: function () {
      var self = this
      const url = '/photodesk/session/add'
      let data = {
        id_channel: 6,
        shoot_type: 'product'
      }

      self.$store.dispatch('updateLoading', 'true')

      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.$store.dispatch('updateLoading', 'false')
          self.$router.push('/photodesk/projects/' + response.data.session.id_photodesk_session)
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('showToastAPIError')
        })
    }
  }
}
</script>

<style scoped>
    .open {
        color:#75da62 !important;
    }
    .closed {
        color: #23b7e5!important;
    }
    .cancelled {
        color: #ddd;
    }
</style>
